import { isFocusable } from "./isFocusable.mjs";
export function focusAttempt(element) {
  if (!isFocusable(element)) {
    return false;
  }
  try {
    element.focus();
  } catch (e) {
  }
  return typeof window !== "undefined" && document.activeElement === element;
}
